import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Sun, BarChart3, Globe, Zap } from 'lucide-react';
export function SoftwareSlide() {
  return <div className="h-full w-full flex flex-col md:flex-row items-center justify-center px-8 md:px-16 bg-slate-950 gap-16" data-id="element-145">
      <motion.div initial={{
      opacity: 0,
      x: -50
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.8
    }} className="flex-1 max-w-lg" data-id="element-146">
        <div className="w-16 h-16 bg-green-500/10 rounded-2xl flex items-center justify-center mb-8" data-id="element-147">
          <Smartphone className="w-8 h-8 text-green-500" data-id="element-148" />
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-149">
          Smart Charging <br data-id="element-150" />
          <span className="text-green-500" data-id="element-151">Energy Management</span>
        </h2>

        <p className="text-lg text-slate-400 mb-8 leading-relaxed" data-id="element-152">
          Deliver a premium experience to your drivers through our white-label
          application or integrate directly via API.
        </p>

        <div className="space-y-6" data-id="element-153">
          <div className="flex gap-4" data-id="element-154">
            <div className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center flex-shrink-0 border border-slate-800" data-id="element-155">
              <Sun className="w-5 h-5 text-yellow-500" data-id="element-156" />
            </div>
            <div data-id="element-157">
              <h4 className="text-white font-semibold" data-id="element-158">Solar Optimization</h4>
              <p className="text-sm text-slate-500" data-id="element-159">
                Maximize self-consumption (e.g., France market needs)
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-160">
            <div className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center flex-shrink-0 border border-slate-800" data-id="element-161">
              <BarChart3 className="w-5 h-5 text-blue-500" data-id="element-162" />
            </div>
            <div data-id="element-163">
              <h4 className="text-white font-semibold" data-id="element-164">Capacity Tariff</h4>
              <p className="text-sm text-slate-500" data-id="element-165">
                Smart peak shaving (e.g., Belgium market needs)
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-166">
            <div className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center flex-shrink-0 border border-slate-800" data-id="element-167">
              <Globe className="w-5 h-5 text-purple-500" data-id="element-168" />
            </div>
            <div data-id="element-169">
              <h4 className="text-white font-semibold" data-id="element-170">Universal Access</h4>
              <p className="text-sm text-slate-500" data-id="element-171">
                Same app for drivers regardless of charger hardware
              </p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      x: 50
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="flex-1 flex justify-center" data-id="element-172">
        <div className="relative w-72 h-[580px] bg-slate-900 rounded-[3rem] border-8 border-slate-800 shadow-2xl overflow-hidden" data-id="element-173">
          {/* Phone Screen Mockup */}
          <div className="absolute top-0 left-0 right-0 h-full bg-slate-950 flex flex-col" data-id="element-174">
            {/* Status Bar */}
            <div className="h-8 w-full flex justify-between items-center px-6 text-[10px] text-white" data-id="element-175">
              <span data-id="element-176">9:41</span>
              <div className="flex gap-1" data-id="element-177">
                <div className="w-3 h-3 bg-white rounded-full opacity-20" data-id="element-178"></div>
                <div className="w-3 h-3 bg-white rounded-full opacity-20" data-id="element-179"></div>
              </div>
            </div>

            {/* App Content */}
            <div className="flex-1 p-6 flex flex-col gap-4" data-id="element-180">
              <div className="bg-blue-600 rounded-2xl p-6 text-white shadow-lg shadow-blue-900/20" data-id="element-181">
                <div className="text-xs opacity-70 mb-1" data-id="element-182">Current Status</div>
                <div className="text-2xl font-bold mb-4" data-id="element-183">Charging</div>
                <div className="flex justify-between items-end" data-id="element-184">
                  <div className="text-4xl font-bold" data-id="element-185">
                    7.4
                    <span className="text-lg font-normal opacity-70" data-id="element-186">kW</span>
                  </div>
                  <div className="text-sm opacity-70" data-id="element-187">85% Full</div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-188">
                <div className="bg-slate-900 border border-slate-800 rounded-2xl p-4" data-id="element-189">
                  <Sun className="w-6 h-6 text-yellow-500 mb-2" data-id="element-190" />
                  <div className="text-xs text-slate-500" data-id="element-191">Solar</div>
                  <div className="text-lg font-bold text-white" data-id="element-192">2.1 kW</div>
                </div>
                <div className="bg-slate-900 border border-slate-800 rounded-2xl p-4" data-id="element-193">
                  <Zap className="w-6 h-6 text-green-500 mb-2" data-id="element-194" />
                  <div className="text-xs text-slate-500" data-id="element-195">Saved</div>
                  <div className="text-lg font-bold text-white" data-id="element-196">€12.50</div>
                </div>
              </div>

              <div className="mt-auto bg-slate-900 border border-slate-800 rounded-2xl p-4" data-id="element-197">
                <div className="text-sm font-medium text-white mb-2" data-id="element-198">
                  Smart Schedule
                </div>
                <div className="h-2 bg-slate-800 rounded-full overflow-hidden" data-id="element-199">
                  <div className="h-full w-2/3 bg-green-500 rounded-full" data-id="element-200"></div>
                </div>
                <div className="flex justify-between text-xs text-slate-500 mt-2" data-id="element-201">
                  <span data-id="element-202">00:00</span>
                  <span data-id="element-203">12:00</span>
                  <span data-id="element-204">24:00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}